import { useRouter, useContext } from "@nuxtjs/composition-api";
function useContentRouter() {
  const { localePath } = useContext();
  const router = useRouter();
  function onLinkClick(event) {
    let target = event.target;
    while (target) {
      if (target instanceof HTMLAnchorElement) {
        const url = target.getAttribute("href");
        if (url.startsWith("/")) {
          event.preventDefault();
          router.push(localePath(url));
        }
        break;
      }
      target = target.parentNode;
    }
  }
  const bind = (el) => {
    if (process.server)
      return;
    const links = el.value.querySelectorAll("a");
    links.forEach((link) => {
      link.addEventListener("click", onLinkClick);
    });
  };
  const unbind = (el) => {
    if (process.server)
      return;
    const links = el.value.querySelectorAll("a");
    links.forEach((link) => {
      link.removeEventListener("click", onLinkClick);
    });
  };
  return {
    bind,
    unbind
  };
}
export * from "./useContentRouter";
var useContentRouter_default = useContentRouter;
export {
  useContentRouter_default as default,
  useContentRouter
};
